

import Vue from 'vue'

import VueRouter from 'vue-router'
import App from './App'
import router from './router/index.js';
import axios from 'axios';
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import Toast from 'vux/src/components/toast/index.vue'

import SlideVerify from 'vue-monoplasty-slide-verify';
import Url from './assets/js/url.js';
import Echarts from 'echarts' 
import 'swiper/dist/css/swiper.css';
let conn = require('./assets/js/conn.js');
let Api = require('./assets/js/api.js').Api;
window._Url = Url
window._Api=Api
window._PayWx = `https://m.oasisapp.cn/payment/#/gwpay`; 
const RouterConfig = {
routes: router
};
Vue.prototype.echarts = Echarts

Vue.config.productionTip = false
Vue.use(VueRouter);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
Vue.use(ConfirmPlugin);
Vue.use(LoadingPlugin);
Vue.use(SlideVerify);
Vue.use(Echarts)
Vue.component('toast', Toast)


/* eslint-disable no-new */
Vue.prototype.$axios = axios;
globle_vue = new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js